module.exports = __webpack_public_path__ + "img/filter-type-chest.b3ea2cf6.svg";